var ProductFreeShippingComponent = Vue.component('product-free-shipping', {
    props: [],
    data: function () {
        return {
        };
    },
    methods: {
    },
    computed: {
    }
});